/* CELESTIAR — Studio Céleste : éditeur photo + textes (Konva). Fichier propre à /pages/studio-celeste. */
(function () {
  "use strict";
  /* largeur de la barre de défilement, pour que l'aperçu pleine largeur reste centré */
  (function(){var d=document.documentElement;function s(){d.style.setProperty("--sbw",(window.innerWidth-d.clientWidth)+"px");}s();window.addEventListener("resize",s);})();
  var CEL_EN = !!(window.CELESTIAR_I18N && window.CELESTIAR_I18N.locale === "en");
  var root = document.querySelector("[data-studio]");
  if (!root || !window.Konva) return;
  function $(s) { return root.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  var MAX_BYTES = 20 * 1024 * 1024;
  var DISPLAY_MAX = 2400;
  var HEIC_MAX = 4000;
  var W = 1000;
  var SIZES = { "13 × 18 cm": [13, 18], "20 × 25 cm": [20, 25], "21 × 30 cm": [21, 30], "30 × 40 cm": [30, 40], "40 × 50 cm": [40, 50], "50 × 70 cm": [50, 70], "60 × 90 cm": [60, 90], "70 × 100 cm": [70, 100] };
  var ROOM_WIDTH = { "13 × 18 cm": 20, "20 × 25 cm": 27, "21 × 30 cm": 28, "30 × 40 cm": 37, "40 × 50 cm": 46, "50 × 70 cm": 58, "60 × 90 cm": 69, "70 × 100 cm": 80 };
  var FRAME_NAMES = { noir: "Noir", blanc: "Blanc", chene: "Chêne" };
  var FONTS = [
    { id: "soie", label: (CEL_EN ? "Silk" : "Soie"), fam: "SC Playfair" }, { id: "soie-fine", label: (CEL_EN ? "Fine silk" : "Soie fine"), fam: "SC Cormorant" },
    { id: "murmure", label: (CEL_EN ? "Whisper" : "Murmure"), fam: "SC GreatVibes" }, { id: "murmure-doux", label: (CEL_EN ? "Soft whisper" : "Murmure doux"), fam: "SC Pinyon" },
    { id: "epure", label: (CEL_EN ? "Clean" : "Épure"), fam: "SC Montserrat" }, { id: "epure-legere", label: (CEL_EN ? "Light clean" : "Épure légère"), fam: "SC Josefin" },
    { id: "carnet", label: (CEL_EN ? "Notebook" : "Carnet"), fam: "SC Caveat" }, { id: "carnet-libre", label: (CEL_EN ? "Free notebook" : "Carnet libre"), fam: "SC Shadows" },
    { id: "nebuleuse", label: (CEL_EN ? "Nebula" : "Nébuleuse"), fam: "SC Cinzel" }, { id: "nebuleuse-antique", label: (CEL_EN ? "Antique nebula" : "Nébuleuse antique"), fam: "SC Marcellus" },
    { id: "gatsby", label: "Gatsby", fam: "SC Poiret" }, { id: "gatsby-neon", label: (CEL_EN ? "Gatsby neon" : "Gatsby néon"), fam: "SC Limelight" },
    { id: "allure", label: (CEL_EN ? "Allure" : "Allure"), fam: "SC Allura" }, { id: "parisienne", label: "Parisienne", fam: "SC Parisienne" },
    { id: "italiana", label: (CEL_EN ? "Italian" : "Italienne"), fam: "SC Italiana" }, { id: "bodoni", label: "Bodoni", fam: "SC Bodoni" },
    { id: "sacramento", label: (CEL_EN ? "Signature" : "Signature"), fam: "SC Sacramento" }, { id: "pinceau", label: (CEL_EN ? "Brush" : "Pinceau"), fam: "SC AlexBrush" }
  ];
  var COLORS = [
    { n: (CEL_EN ? "Ivory" : "Ivoire"), c: "#F6F1E4" }, { n: (CEL_EN ? "Champagne gold" : "Or champagne"), c: "#D8BE84" }, { n: (CEL_EN ? "Moon silver" : "Argent lune"), c: "#C9CED6" }, { n: (CEL_EN ? "Dawn pink" : "Rose aurore"), c: "#E8B4B0" },
    { n: (CEL_EN ? "Midnight blue" : "Bleu minuit"), c: "#1C2547" }, { n: (CEL_EN ? "Pearly lilac" : "Lilas nacré"), c: "#C8B6E2" }, { n: (CEL_EN ? "Sage green" : "Vert sauge"), c: "#9CAF94" }, { n: (CEL_EN ? "Ink black" : "Noir encre"), c: "#15151A" },
    { n: (CEL_EN ? "Burgundy" : "Bordeaux"), c: "#7A1F3A" }, { n: (CEL_EN ? "Rose gold" : "Or rose"), c: "#D9A79B" }, { n: (CEL_EN ? "Glacier blue" : "Bleu glacier"), c: "#A9D4EE" }, { n: (CEL_EN ? "Emerald" : "Émeraude"), c: "#2E8B6A" },
    { n: (CEL_EN ? "Amethyst" : "Améthyste"), c: "#8A63C9" }, { n: (CEL_EN ? "Copper" : "Cuivre"), c: "#C47A4E" }, { n: (CEL_EN ? "Pure white" : "Blanc pur"), c: "#FFFFFF" }, { n: (CEL_EN ? "Deep gold" : "Or profond"), c: "#B8903A" }
  ];
  var METALS = {
    or: [0, "#8a6a2f", 0.3, "#f6e7b8", 0.5, "#c9a85c", 0.72, "#fff3cf", 1, "#a07b3c"],
    argent: [0, "#7d838c", 0.3, "#f4f6f8", 0.5, "#b9bfc7", 0.72, "#ffffff", 1, "#8d939c"],
    cuivre: [0, "#7a3d1c", 0.3, "#f3b890", 0.5, "#c47a4e", 0.72, "#ffd9bd", 1, "#8f4f2a"],
    rose: [0, "#9a6258", 0.3, "#f8dcd2", 0.5, "#d9a79b", 0.72, "#ffeee8", 1, "#a8706a"],
    perle: [0, "#a9a4b8", 0.3, "#ffffff", 0.5, "#d9d4e6", 0.72, "#fbf8ff", 1, "#b3aec4"]
  };
  var FILTERS = [
    { id: "original", label: "Original" }, { id: "nb", label: (CEL_EN ? "Black & white" : "Noir & blanc") }, { id: "sepia", label: (CEL_EN ? "Sepia" : "Sépia") },
    { id: "chaud", label: (CEL_EN ? "Warm" : "Chaud") }, { id: "froid", label: (CEL_EN ? "Cool" : "Froid") }, { id: "doux", label: (CEL_EN ? "Soft" : "Doux") },
    { id: "nuit", label: (CEL_EN ? "Night sky" : "Ciel de nuit") }, { id: "aurore", label: (CEL_EN ? "Aurora" : "Aurore") }, { id: "cine", label: (CEL_EN ? "Cinema" : "Ciné") },
    { id: "pellicule", label: (CEL_EN ? "Film" : "Pellicule") }, { id: "dore", label: (CEL_EN ? "Golden hour" : "Heure dorée") }, { id: "mat", label: (CEL_EN ? "Matte" : "Mat") },
    { id: "contraste", label: (CEL_EN ? "Contrast" : "Contraste") }, { id: "nbfort", label: (CEL_EN ? "Bold B&W" : "N&B intense") }
  ];
  var DOTS = [[12, 72], [32, 40], [58, 52], [86, 22], [72, 84]].map(function (p) { return "M" + (p[0] - 3.5) + " " + p[1] + " a3.5 3.5 0 1 0 7 0 a3.5 3.5 0 1 0 -7 0"; }).join(" ");
  var ORN = {
    etoile: { label: (CEL_EN ? "Star" : "Étoile"), parts: [{ d: "M50 4 L61 38 L97 38 L68 59 L79 94 L50 72 L21 94 L32 59 L3 38 L39 38 Z" }] },
    etincelle: { label: (CEL_EN ? "Sparkle" : "Étincelle"), parts: [{ d: "M50 0 C54 35 65 46 100 50 C65 54 54 65 50 100 C46 65 35 54 0 50 C35 46 46 35 50 0 Z" }] },
    lune: { label: (CEL_EN ? "Crescent moon" : "Croissant de lune"), parts: [{ d: "M62 6 A46 46 0 1 0 94 70 A38 38 0 1 1 62 6 Z" }] },
    coeur: { label: (CEL_EN ? "Fine heart" : "Cœur fin"), parts: [{ d: "M50 88 C20 66 6 50 6 32 C6 18 17 8 30 8 C40 8 46 14 50 22 C54 14 60 8 70 8 C83 8 94 18 94 32 C94 50 80 66 50 88 Z", stroke: 3 }] },
    filet: { label: (CEL_EN ? "Decorative line" : "Filet décoratif"), parts: [{ d: "M2 50 L40 50 M60 50 L98 50", stroke: 2 }, { d: "M50 41 L58 50 L50 59 L42 50 Z" }] },
    constellation: { label: "Constellation", parts: [{ d: "M12 72 L32 40 L58 52 L86 22 M58 52 L72 84", stroke: 1.2 }, { d: DOTS }] }
  };
  (function extraOrn() {
    function flake() { var d = ""; for (var a = 0; a < 6; a++) { var t = a * Math.PI / 3, c = Math.cos(t), s = Math.sin(t), P = function (r, q) { return (50 + r * c - q * s).toFixed(1) + " " + (50 + r * s + q * c).toFixed(1); }; d += "M50 50 L" + P(44, 0) + " M" + P(30, 0) + " L" + P(38, 8) + " M" + P(30, 0) + " L" + P(38, -8) + " M" + P(18, 0) + " L" + P(25, 6) + " M" + P(18, 0) + " L" + P(25, -6) + " "; } return d; }
    function leaf(x, y, ang, L, w) { var c = Math.cos(ang), s = Math.sin(ang), P = function (u, v) { return (x + u * c - v * s).toFixed(1) + " " + (y + u * s + v * c).toFixed(1); }; return "M" + P(0, 0) + " Q" + P(L * 0.5, -w) + " " + P(L, 0) + " Q" + P(L * 0.5, w) + " " + P(0, 0) + " Z "; }
    function laurel() { var d = ""; for (var side = -1; side <= 1; side += 2) for (var k = 0; k < 9; k++) { var th = (Math.PI / 2) + side * (0.22 + k * 0.2), px = 50 + 38 * Math.cos(th), py = 50 + 38 * Math.sin(th), tang = th - side * Math.PI / 2; d += leaf(px, py, tang + side * 0.5, 15, 4.5) + leaf(px, py, tang - side * 0.5 + (side > 0 ? 0 : 0), 13, 3.8); } return d; }
    var moons = [], i; for (i = 0; i < 5; i++) { var cx = 10 + i * 20; moons.push({ d: "M" + (cx - 8) + " 50 a8 8 0 1 0 16 0 a8 8 0 1 0 -16 0", stroke: 1.6 }); if (i === 1) moons.push({ d: "M" + cx + " 42 A8 8 0 0 1 " + cx + " 58 Z" }); if (i === 2) moons.push({ d: "M" + (cx - 8) + " 50 a8 8 0 1 0 16 0 a8 8 0 1 0 -16 0" }); if (i === 3) moons.push({ d: "M" + cx + " 42 A8 8 0 0 0 " + cx + " 58 Z" }); }
    ORN.flocon = { label: CEL_EN ? "Snowflake" : "Flocon", parts: [{ d: flake(), stroke: 2.2 }] };
    ORN.sapin = { label: CEL_EN ? "Tree" : "Sapin", parts: [{ d: "M50 6 L72 38 H62 L82 66 H58 V90 H42 V66 H18 L38 38 H28 Z", stroke: 2.4 }, { d: "M50 14 l2 5 5 .5 -4 3.5 1.2 5 -4.2 -2.8 -4.2 2.8 1.2 -5 -4 -3.5 5 -.5 z" }] };
    ORN.alliances = { label: CEL_EN ? "Wedding rings" : "Alliances", parts: [{ d: "M14 56 a24 24 0 1 0 48 0 a24 24 0 1 0 -48 0", stroke: 3 }, { d: "M38 56 a24 24 0 1 0 48 0 a24 24 0 1 0 -48 0", stroke: 3 }, { d: "M62 24 l5 -7 l5 7 l-5 5 z" }] };
    ORN.laurier = { label: CEL_EN ? "Laurel wreath" : "Couronne de laurier", parts: [{ d: laurel() }] };
    ORN.phases = { label: CEL_EN ? "Moon phases" : "Phases de lune", parts: moons };
    ORN.boussole = { label: CEL_EN ? "Compass rose" : "Rose des vents", parts: [{ d: "M50 4 L58 42 L96 50 L58 58 L50 96 L42 58 L4 50 L42 42 Z" }, { d: "M18 50 a32 32 0 1 0 64 0 a32 32 0 1 0 -64 0", stroke: 1.2 }] };
    ORN.couronne = { label: CEL_EN ? "Crown" : "Couronne", parts: [{ d: "M10 74 L16 32 L34 52 L50 22 L66 52 L84 32 L90 74 Z", stroke: 2.6 }, { d: "M10 84 H90", stroke: 2.6 }] };
    ORN.infini = { label: CEL_EN ? "Infinity" : "Infini", parts: [{ d: "M50 50 C62 30 90 30 90 50 C90 70 62 70 50 50 C38 30 10 30 10 50 C10 70 38 70 50 50 Z", stroke: 3.2 }] };
    ORN.filante = { label: CEL_EN ? "Shooting star" : "Étoile filante", parts: [{ d: "M72 28 L76 38 L87 39 L79 46 L81 57 L72 51 L63 57 L65 46 L57 39 L68 38 Z" }, { d: "M60 44 L6 90 M56 34 L14 62 M66 56 L30 92", stroke: 1.6 }] };
  })();
  var TEMPLATES = {
    naissance: { texts: [{ raw: "Bienvenue Léa", font: "murmure", size: 96, effect: "halo", y: 0.74 }, { raw: "12 mars 2026 · 3,2 kg · 50 cm", font: "epure-legere", size: 30, ls: 4, caseMode: "upper", color: "#D8BE84", y: 0.84 }], orn: [{ type: "etoile", x: 0.5, y: 0.64, s: 0.35, color: "#D8BE84" }] },
    mariage: { texts: [{ raw: "Camille & Hugo", font: "murmure", size: 100, effect: "halo", y: 0.74 }, { raw: "Pour la vie · 14.06.2025", font: "nebuleuse", size: 30, ls: 6, effect: "eclat", metal: "or", y: 0.85 }], orn: [{ type: "filet", x: 0.5, y: 0.8, s: 2.2, color: "#D8BE84" }] },
    anniversaire: { texts: [{ raw: "Joyeux anniversaire", font: "gatsby", size: 70, effect: "eclat", metal: "or", y: 0.76 }, { raw: "Maman · 60 ans", font: "soie-fine", size: 48, y: 0.85 }], orn: [{ type: "etincelle", x: 0.2, y: 0.12, s: 0.4, color: "#D8BE84" }, { type: "etincelle", x: 0.82, y: 0.18, s: 0.25, color: "#F6F1E4" }] },
    couple: { texts: [{ raw: "Nous deux", font: "soie", size: 96, y: 0.76 }, { raw: "depuis le premier regard", font: "carnet", size: 46, color: "#E8B4B0", effect: "halo", haloColor: "#E8B4B0", y: 0.85 }], orn: [{ type: "coeur", x: 0.5, y: 0.66, s: 0.32, color: "#E8B4B0" }] },
    voyage: { texts: [{ raw: "Quelque part à Lisbonne", font: "carnet", size: 70, y: 0.78 }, { raw: "Été 2025 · 38.72° N  9.13° O", font: "epure-legere", size: 28, ls: 5, caseMode: "upper", color: "#C9CED6", y: 0.86 }], orn: [{ type: "constellation", x: 0.8, y: 0.14, s: 0.9, color: "#F6F1E4" }] },
    noel: { texts: [{ raw: "Joyeux Noël", font: "allure", size: 118, effect: "eclat", metal: "or", y: 0.74 }, { raw: "Famille Martin · 2026", font: "epure-legere", size: 30, ls: 6, caseMode: "upper", color: "#F6F1E4", y: 0.85 }], orn: [{ type: "flocon", x: 0.5, y: 0.62, s: 0.55, color: "#D8BE84" }] },
    valentin: { texts: [{ raw: "Je t’aime", font: "parisienne", size: 120, effect: "halo", haloColor: "#E8B4B0", y: 0.74 }, { raw: "14 février · pour toujours", font: "soie-fine", size: 38, color: "#E8B4B0", y: 0.85 }], orn: [{ type: "alliances", x: 0.5, y: 0.63, s: 0.5, color: "#E8B4B0" }] },
    hommage: { texts: [{ raw: "À jamais dans nos cœurs", font: "italiana", size: 66, effect: "voile", y: 0.76 }, { raw: "Papa · 1948 – 2026", font: "epure-legere", size: 30, ls: 6, caseMode: "upper", color: "#C9CED6", y: 0.85 }], orn: [{ type: "filante", x: 0.5, y: 0.62, s: 0.55, color: "#F6F1E4" }] },
    famille: { texts: [{ raw: "Notre famille", font: "pinceau", size: 110, effect: "voile", y: 0.74 }, { raw: "Depuis 2012 · Lyon", font: "soie-fine", size: 38, color: "#D8BE84", y: 0.85 }], orn: [{ type: "laurier", x: 0.5, y: 0.62, s: 0.6, color: "#D8BE84" }] }
  };
  var INSPIRE = [
    { font: "murmure", color: "#F6F1E4", effect: "halo", haloColor: "#D8BE84" }, { font: "nebuleuse", color: "#D8BE84", effect: "eclat", metal: "or", ls: 6 },
    { font: "gatsby", color: "#C9CED6", effect: "eclat", metal: "argent", ls: 4 }, { font: "soie", color: "#F6F1E4", effect: "voile" },
    { font: "carnet", color: "#E8B4B0", effect: "halo", haloColor: "#E8B4B0" }, { font: "epure-legere", color: "#C8B6E2", effect: "halo", haloColor: "#C8B6E2", ls: 8, caseMode: "upper" },
    { font: "murmure-doux", color: "#D8BE84", effect: "eclat", metal: "or" }, { font: "soie-fine", color: "#9CAF94", effect: "voile" }
  ];
  var MSG = {
    type: (CEL_EN ? "This format is not supported. Please choose a JPG, PNG or HEIC photo." : "Ce format n'est pas pris en charge. Choisissez une photo JPG, PNG ou HEIC."),
    size: (CEL_EN ? "This photo exceeds 20 MB. Please choose a smaller version." : "Cette photo dépasse 20 Mo. Choisissez une version plus légère."),
    read: (CEL_EN ? "We could not open this photo. Please try another image in JPG or PNG." : "Nous n'avons pas pu ouvrir cette photo. Essayez avec une autre image, en JPG ou PNG."),
    noPhoto: (CEL_EN ? "Please upload your photo in step 01 first." : "Importez d'abord votre photo à l'étape 01."),
    checks: (CEL_EN ? "Please tick both boxes above to confirm your creation." : "Cochez les deux cases ci-dessus pour confirmer votre création."),
    variant: (CEL_EN ? "This size is temporarily unavailable." : "Ce format est momentanément indisponible."),
    cart: (CEL_EN ? "Something prevented the item from being added to your cart. Please try again in a moment." : "Une interférence a empêché l'ajout au panier. Réessayez dans un instant."),
    added: (CEL_EN ? "Your frame is ready to come to life ✦" : "Votre cadre est prêt à prendre vie ✦")
  };

  var state = { size: "30 × 40 cm", frame: "noir", support: "cadre", file: null, natural: null, displayFactor: 1, base: null, filter: "original", filtered: {} };
  var H = W * 30 / 21;
  var texts = [];
  var orns = [];
  var selected = null;
  var photo = null;

  /* --- Scène Konva --- */
  Konva.hitOnDragEnabled = true;
  var stageEl = $("[data-studio-stage]");
  var frameEl = $("[data-studio-frame]");
  var holder = $("[data-studio-holder]");
  var stage = new Konva.Stage({ container: stageEl, width: 10, height: 10 });
  var bgLayer = new Konva.Layer();
  var textLayer = new Konva.Layer();
  var uiLayer = new Konva.Layer({ listening: false });
  var matLayer = new Konva.Layer({ listening: false });
  var fxLayer = new Konva.Layer({ listening: false });
  var lineLayer = new Konva.Layer({ listening: false });
  stage.add(bgLayer); stage.add(fxLayer); stage.add(matLayer); stage.add(lineLayer); stage.add(textLayer); stage.add(uiLayer);
  var paper = new Konva.Rect({ x: 0, y: 0, width: W, height: H, fill: "#F6F1E4" });
  bgLayer.add(paper);
  var photoGroup = new Konva.Group();
  bgLayer.add(photoGroup);
  var safety = new Konva.Rect({ stroke: "rgba(201,168,92,.9)", strokeWidth: 2, dash: [12, 9], strokeScaleEnabled: false });
  uiLayer.add(safety);
  var tr = new Konva.Transformer({
    rotateEnabled: true, keepRatio: true, enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
    anchorFill: "#C9A85C", anchorStroke: "#FFF8E1", borderStroke: "#C9A85C", borderDash: [4, 3],
    anchorSize: window.matchMedia("(pointer: coarse)").matches ? 20 : 12, anchorCornerRadius: 10, padding: 8, rotateAnchorOffset: 30
  });
  textLayer.add(tr);

  /* Passe-partout : bordure posee par-dessus la photo (jamais deformee), incluse dans l apercu et dans l image envoyee */
  var MATS = { aucun: null, fin: [0.05, 0.05, 0.05, 0.05], large: [0.1, 0.1, 0.1, 0.1], polaroid: [0.07, 0.07, 0.19, 0.07] };
  var MAT_COLORS = { ivoire: "#F4EEDC", blanc: "#FFFFFF", noir: "#101014", sable: "#E3D5B8" };
  var MAT_NAMES = { aucun: "Aucun", fin: "Fin", large: "Large", polaroid: "Polaroid" };
  var mat = { type: "aucun", color: "ivoire" };
  function drawMat() {
    matLayer.destroyChildren();
    var spec = MATS[mat.type]; if (!spec) { matLayer.batchDraw(); return; }
    var l = W * spec[3], r = W * spec[1], tp = W * spec[0], bt = W * spec[2], col = MAT_COLORS[mat.color] || MAT_COLORS.ivoire;
    [[0, 0, W, tp], [0, H - bt, W, bt], [0, tp, l, H - tp - bt], [W - r, tp, r, H - tp - bt]].forEach(function (q) { matLayer.add(new Konva.Rect({ x: q[0], y: q[1], width: q[2], height: q[3], fill: col })); });
    var lw = Math.max(1.5, W * 0.0035);
    matLayer.add(new Konva.Rect({ x: l, y: tp, width: W - l - r, height: H - tp - bt, stroke: "rgba(0,0,0,0.28)", strokeWidth: lw }));
    matLayer.add(new Konva.Rect({ x: l + lw, y: tp + lw, width: W - l - r - 2 * lw, height: H - tp - bt - 2 * lw, stroke: "rgba(255,255,255,0.35)", strokeWidth: Math.max(1, lw * 0.5) }));
    matLayer.batchDraw();
  }
  function setMat(type, color) {
    if (type) mat.type = type; if (color) mat.color = color;
    $$("[data-studio-mat]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-studio-mat") === mat.type); });
    $$("[data-studio-matcolor]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-studio-matcolor") === mat.color); });
    var cr = $("[data-studio-matcolors]"); if (cr) cr.hidden = mat.type === "aucun";
    drawMat(); updateRoom();
  }
﻿  /* ===== Mise en forme : forme de la photo, papier, liseré doré, voile de lumière ===== */
  var PAPERS = { ivoire: ["#F6F1E4", CEL_EN ? "Ivory" : "Ivoire"], blanc: ["#FFFFFF", CEL_EN ? "White" : "Blanc"], noir: ["#101014", CEL_EN ? "Black" : "Noir"], nuit: ["#0b1432", CEL_EN ? "Midnight blue" : "Bleu nuit"],
    bordeaux: ["#3a1220", CEL_EN ? "Burgundy" : "Bordeaux"], foret: ["#0f2c24", CEL_EN ? "Forest green" : "Vert forêt"], rose: ["#F2D8D8", CEL_EN ? "Powder pink" : "Rose poudré"], sable: ["#E3D5B8", CEL_EN ? "Sand" : "Sable"], prune: ["#2a1236", CEL_EN ? "Plum" : "Prune"] };
  var LINES = { or: METALS.or, argent: METALS.argent, cuivre: METALS.cuivre, rose: METALS.rose, blanc: [0, "#ffffff", 1, "#e9e9ee"] };
  var LOOK0 = { shape: "rect", margin: 9, paper: "ivoire", line: "aucun", lineStyle: "fin", veil: "aucun", veilInt: 60 };
  var look = JSON.parse(JSON.stringify(LOOK0));
  function shapeBox() {
    var m = W * look.margin / 100, w = W - 2 * m, h, s = look.shape;
    if (s === "cadre") h = H - 2 * m; else if (s === "cercle") h = w; else if (s === "ovale") h = w * 1.28; else if (s === "arche") h = w * 1.45; else if (s === "coeur") h = w * 0.94; else if (s === "etoile") h = w * 0.96; else if (s === "hexagone") h = w * 1.1547; else h = H;
    if (h > H - 2 * m) { var k = (H - 2 * m) / h; h *= k; if (s !== "cadre") w *= k; }
    var cy = (s === "cadre") ? H / 2 : Math.max(m + h / 2, Math.min(H * 0.44, H - m - h / 2));
    return { cx: W / 2, cy: cy, w: w, h: h };
  }
  function shapePathP(c, s, cx, cy, w, h) {
    var x0 = cx - w / 2, y0 = cy - h / 2, i;
    c.beginPath();
    if (s === "cercle" || s === "ovale") c.ellipse(cx, cy, w / 2, h / 2, 0, 0, Math.PI * 2);
    else if (s === "cadre" || s === "rect") { var r = Math.min(w, h) * 0.012; c.moveTo(x0 + r, y0); c.lineTo(x0 + w - r, y0); c.quadraticCurveTo(x0 + w, y0, x0 + w, y0 + r); c.lineTo(x0 + w, y0 + h - r); c.quadraticCurveTo(x0 + w, y0 + h, x0 + w - r, y0 + h); c.lineTo(x0 + r, y0 + h); c.quadraticCurveTo(x0, y0 + h, x0, y0 + h - r); c.lineTo(x0, y0 + r); c.quadraticCurveTo(x0, y0, x0 + r, y0); c.closePath(); }
    else if (s === "arche") { var ra = w / 2; c.moveTo(x0, y0 + h); c.lineTo(x0, y0 + ra); c.arc(cx, y0 + ra, ra, Math.PI, 0, false); c.lineTo(x0 + w, y0 + h); c.closePath(); }
    else if (s === "coeur") { var sx = w / 32, sy = h / 29, n = 120; for (i = 0; i <= n; i++) { var t = i / n * Math.PI * 2, hx = 16 * Math.pow(Math.sin(t), 3), hy = 13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t), px = cx + hx * sx, py = cy - (hy + 2.5) * sy; if (i === 0) c.moveTo(px, py); else c.lineTo(px, py); } c.closePath(); }
    else if (s === "etoile") { var Ro = w / 1.902, Ri = Ro * 0.5, yc = y0 + Ro; for (i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? Ri : Ro; if (i === 0) c.moveTo(cx + rr * Math.cos(a), yc + rr * Math.sin(a)); else c.lineTo(cx + rr * Math.cos(a), yc + rr * Math.sin(a)); } c.closePath(); }
    else if (s === "hexagone") { for (i = 0; i < 6; i++) { var b = -Math.PI / 2 + i * Math.PI / 3; if (i === 0) c.moveTo(cx + h / 2 * Math.cos(b), cy + h / 2 * Math.sin(b)); else c.lineTo(cx + h / 2 * Math.cos(b), cy + h / 2 * Math.sin(b)); } c.closePath(); }
  }
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function sparkPath(c, x, y, s) { var k = s * 0.18; c.beginPath(); c.moveTo(x, y - s); c.quadraticCurveTo(x + k, y - k, x + s, y); c.quadraticCurveTo(x + k, y + k, x, y + s); c.quadraticCurveTo(x - k, y + k, x - s, y); c.quadraticCurveTo(x - k, y - k, x, y - s); c.closePath(); c.fill(); }
  function paintVeil(c) {
    var k = look.veilInt / 100, r = rng(7), i, g;
    c.save();
    if (look.veil === "etoiles") {
      for (i = 0; i < 170; i++) { var x = r() * W, y = r() * H, s = 0.8 + Math.pow(r(), 3) * 3.4; c.globalAlpha = (0.3 + 0.65 * r()) * k; c.fillStyle = r() > 0.78 ? "#F6E7B8" : "#FFFFFF"; c.beginPath(); c.arc(x, y, s, 0, Math.PI * 2); c.fill(); }
      for (i = 0; i < 14; i++) { c.globalAlpha = (0.55 + 0.4 * r()) * k; c.fillStyle = "#FFF4D6"; sparkPath(c, r() * W, r() * H, 10 + r() * 16); }
    } else if (look.veil === "filantes") {
      for (i = 0; i < 6; i++) { var sx = W * (0.25 + 0.7 * r()), sy = H * (0.04 + 0.5 * r()), len = 160 + 150 * r(), ex = sx - len * 0.82, ey = sy + len * 0.57; g = c.createLinearGradient(sx, sy, ex, ey); g.addColorStop(0, "rgba(255,246,214," + (0.95 * k) + ")"); g.addColorStop(1, "rgba(255,246,214,0)"); c.strokeStyle = g; c.lineWidth = 2.6; c.lineCap = "round"; c.beginPath(); c.moveTo(sx, sy); c.lineTo(ex, ey); c.stroke(); c.globalAlpha = k; c.fillStyle = "#FFFFFF"; c.beginPath(); c.arc(sx, sy, 3.4, 0, Math.PI * 2); c.fill(); c.globalAlpha = 0.35 * k; c.beginPath(); c.arc(sx, sy, 9, 0, Math.PI * 2); c.fill(); c.globalAlpha = 1; }
    } else if (look.veil === "aurore") {
      c.globalCompositeOperation = "screen";
      [[0.2, "60,230,170", 0.42], [0.55, "120,130,255", 0.36], [0.85, "255,130,200", 0.28]].forEach(function (b) { g = c.createRadialGradient(W * b[0], H * 0.12, 0, W * b[0], H * 0.12, W * 0.85); g.addColorStop(0, "rgba(" + b[1] + "," + (b[2] * k) + ")"); g.addColorStop(1, "rgba(" + b[1] + ",0)"); c.fillStyle = g; c.fillRect(0, 0, W, H); });
    } else if (look.veil === "lueur") {
      c.globalCompositeOperation = "screen"; g = c.createRadialGradient(W * 0.78, H * 0.14, 0, W * 0.78, H * 0.14, W * 0.9); g.addColorStop(0, "rgba(255,214,140," + (0.7 * k) + ")"); g.addColorStop(1, "rgba(255,214,140,0)"); c.fillStyle = g; c.fillRect(0, 0, W, H);
    } else if (look.veil === "vignette") {
      g = c.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.35, W / 2, H / 2, Math.max(W, H) * 0.78); g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, "rgba(0,0,0," + (0.75 * k) + ")"); c.fillStyle = g; c.fillRect(0, 0, W, H);
    } else if (look.veil === "bas") {
      g = c.createLinearGradient(0, H * 0.5, 0, H); g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, "rgba(0,0,0," + (0.82 * k) + ")"); c.fillStyle = g; c.fillRect(0, H * 0.5, W, H * 0.5);
    }
    c.restore();
  }
  function drawLookNodes() {
    fxLayer.destroyChildren(); lineLayer.destroyChildren();
    if (look.veil !== "aucun") fxLayer.add(new Konva.Shape({ listening: false, sceneFunc: function (ctx) { paintVeil(ctx._context); } }));
    if (look.line !== "aucun" && LINES[look.line]) {
      var stops = LINES[look.line], rect = look.shape === "rect", b = rect ? { cx: W / 2, cy: H / 2, w: W * 0.93, h: H * 0.93 } : shapeBox(), sh = rect ? "cadre" : look.shape, lw = Math.max(2, W * 0.0034);
      var strokeAt = function (grow, wd, alpha) { lineLayer.add(new Konva.Shape({ listening: false, sceneFunc: function (ctx) { var c = ctx._context; c.save(); var g = c.createLinearGradient(0, 0, W, H); for (var q = 0; q < stops.length; q += 2) g.addColorStop(stops[q], stops[q + 1]); c.strokeStyle = g; c.lineWidth = wd; c.lineJoin = "round"; c.globalAlpha = alpha; shapePathP(c, sh, b.cx, b.cy, b.w + 2 * grow, b.h + 2 * grow); c.stroke(); c.restore(); } })); };
      if (rect) { strokeAt(0, lw, 1); if (look.lineStyle === "double") strokeAt(W * 0.017, lw * 0.5, 0.75); }
      else { strokeAt(W * 0.012, lw, 1); if (look.lineStyle === "double") strokeAt(W * 0.03, lw * 0.5, 0.75); }
    }
  }
  function applyLook() {
    paper.fill(PAPERS[look.paper][0]);
    var clip = null;
    if (look.shape !== "rect") { var b = shapeBox(), s = look.shape; clip = function (ctx) { shapePathP(ctx._context || ctx, s, b.cx, b.cy, b.w, b.h); }; }
    photoGroup.clipFunc(clip); fxLayer.clipFunc(clip);
    drawLookNodes();
    bgLayer.batchDraw(); fxLayer.batchDraw(); lineLayer.batchDraw();
    updateRoom();
  }
  function lookCfg() { return { forme: look.shape, marge: look.margin, papier: PAPERS[look.paper][1], filet: look.line, styleFilet: look.lineStyle, voile: look.veil, intensiteVoile: look.veilInt }; }
  function setLook(p) {
    for (var k in p) look[k] = p[k];
    if (!PAPERS[look.paper]) look.paper = "ivoire";
    $$("[data-look-shape]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-look-shape") === look.shape); });
    $$("[data-look-paper]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-look-paper") === look.paper); });
    $$("[data-look-line]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-look-line") === look.line); });
    $$("[data-look-lstyle]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-look-lstyle") === look.lineStyle); });
    $$("[data-look-veil]").forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute("data-look-veil") === look.veil); });
    var mw = $("[data-look-margin-wrap]"), vw = $("[data-look-vint-wrap]"), lw2 = $("[data-look-lstyle-wrap]");
    if (mw) mw.hidden = look.shape === "rect"; if (vw) vw.hidden = look.veil === "aucun"; if (lw2) lw2.hidden = look.line === "aucun";
    var mi = $("[data-look-margin]"), vi = $("[data-look-vint]"); if (mi) mi.value = look.margin; if (vi) vi.value = look.veilInt;
    applyLook();
  }
  (function buildLook() {
    var box = $("[data-studio-look]"); if (!box) return;
    var T2 = function (fr, en) { return CEL_EN ? en : fr; };
    function group(title, inner) { return '<p class="field-label" style="margin-top:16px;">' + title + '</p>' + inner; }
    function chips(attr, items) { return '<div class="studio__chips">' + items.map(function (x) { return '<button type="button" class="studio__chip" ' + attr + '="' + x[0] + '" data-testid="studio-look-' + x[0] + '">' + x[1] + '</button>'; }).join("") + '</div>'; }
    var html = group(T2("Forme de la photo", "Photo shape"), chips("data-look-shape", [["rect", T2("Pleine page", "Full page")], ["cadre", T2("Encadrée", "Framed")], ["cercle", T2("Cercle", "Circle")], ["ovale", T2("Ovale", "Oval")], ["arche", T2("Arche", "Arch")], ["coeur", T2("Cœur", "Heart")], ["etoile", T2("Étoile", "Star")], ["hexagone", T2("Hexagone", "Hexagon")]]))
      + '<div data-look-margin-wrap hidden><label class="field-label" for="look-margin">' + T2("Marge autour de la photo", "Margin around the photo") + '</label><input type="range" id="look-margin" min="4" max="22" value="9" data-look-margin></div>'
      + group(T2("Papier (fond autour de la photo)", "Paper (background around the photo)"), '<div class="studio__colors">' + Object.keys(PAPERS).map(function (k) { return '<button type="button" class="studio__swatch" style="background:' + PAPERS[k][0] + '" title="' + PAPERS[k][1] + '" aria-label="' + PAPERS[k][1] + '" data-look-paper="' + k + '" data-testid="studio-paper-' + k + '"></button>'; }).join("") + '</div>')
      + group(T2("Liseré métallisé", "Metallic border line"), chips("data-look-line", [["aucun", T2("Aucun", "None")], ["or", T2("Or", "Gold")], ["argent", T2("Argent", "Silver")], ["cuivre", T2("Cuivre", "Copper")], ["rose", T2("Or rose", "Rose gold")], ["blanc", T2("Blanc", "White")]]))
      + '<div data-look-lstyle-wrap hidden style="margin-top:8px;">' + chips("data-look-lstyle", [["fin", T2("Filet simple", "Single line")], ["double", T2("Double filet", "Double line")]]) + '</div>'
      + group(T2("Voile de lumière", "Light veil"), chips("data-look-veil", [["aucun", T2("Aucun", "None")], ["etoiles", T2("Pluie d’étoiles", "Star shower")], ["filantes", T2("Étoiles filantes", "Shooting stars")], ["aurore", T2("Aurore", "Aurora")], ["lueur", T2("Lueur dorée", "Golden glow")], ["vignette", T2("Vignette", "Vignette")], ["bas", T2("Dégradé bas (texte lisible)", "Bottom fade (readable text)")]]))
      + '<div data-look-vint-wrap hidden><label class="field-label" for="look-vint">' + T2("Intensité du voile", "Veil intensity") + '</label><input type="range" id="look-vint" min="10" max="100" value="60" data-look-vint></div>';
    box.innerHTML = html;
    $$("[data-look-shape]").forEach(function (b) { b.addEventListener("click", function () { setLook({ shape: b.getAttribute("data-look-shape") }); sparkle(); }); });
    $$("[data-look-paper]").forEach(function (b) { b.addEventListener("click", function () { var pk = b.getAttribute("data-look-paper"), dk = { noir: 1, nuit: 1, bordeaux: 1, foret: 1, prune: 1 }[pk] ? 1 : 0; texts.forEach(function (t) { var c = String(t.fill()).toUpperCase(); if (dk && (c === "#1C2547" || c === "#15151A")) t.fill("#F6F1E4"); else if (!dk && (c === "#F6F1E4" || c === "#FFFFFF")) t.fill("#1C2547"); }); textLayer.batchDraw(); setLook({ paper: pk }); syncEditor(); }); });
    $$("[data-look-line]").forEach(function (b) { b.addEventListener("click", function () { setLook({ line: b.getAttribute("data-look-line") }); sparkle(); }); });
    $$("[data-look-lstyle]").forEach(function (b) { b.addEventListener("click", function () { setLook({ lineStyle: b.getAttribute("data-look-lstyle") }); }); });
    $$("[data-look-veil]").forEach(function (b) { b.addEventListener("click", function () { setLook({ veil: b.getAttribute("data-look-veil") }); sparkle(); }); });
    $("[data-look-margin]").addEventListener("input", function (e) { setLook({ margin: +e.target.value }); });
    $("[data-look-vint]").addEventListener("input", function (e) { setLook({ veilInt: +e.target.value }); });
  })();

  function updateSafety() {
    var m = Math.round(Math.min(W, H) * 0.04);
    safety.setAttrs({ x: m, y: m, width: W - 2 * m, height: H - 2 * m });
  }

  function fit() {
    var mobile = window.innerWidth <= 900;
    var cs = getComputedStyle(frameEl);
    var pad = parseFloat(cs.paddingLeft) * 2;
    var availW = holder.clientWidth - pad - 16;
    var maxH = (mobile ? window.innerHeight * 0.38 : window.innerHeight * 0.7) - pad;
    var s = Math.max(0.1, Math.min(availW / W, maxH / H));
    stage.width(Math.round(W * s)); stage.height(Math.round(H * s)); stage.scale({ x: s, y: s });
    stage.batchDraw();
  }

  /* --- Étincelles --- */
  var sparkBox = $("[data-studio-sparkles]");
  function sparkle(x, y) {
    if (x == null) { var r = stageEl.getBoundingClientRect(), hr = holder.getBoundingClientRect(); x = r.left - hr.left + r.width / 2; y = r.top - hr.top + r.height / 2; }
    for (var i = 0; i < 10; i++) {
      var s = document.createElement("span");
      var a = Math.PI * 2 * i / 10 + Math.random() * 0.4, d = 26 + Math.random() * 30;
      s.className = "studio__spark";
      s.style.left = x + "px"; s.style.top = y + "px";
      s.style.setProperty("--dx", Math.cos(a) * d + "px"); s.style.setProperty("--dy", Math.sin(a) * d + "px");
      sparkBox.appendChild(s);
      setTimeout(function (el) { el.remove(); }.bind(null, s), 950);
    }
  }
  function sparkleNode(n) {
    var p = n.getAbsolutePosition(), r = stageEl.getBoundingClientRect(), hr = holder.getBoundingClientRect();
    sparkle(r.left - hr.left + p.x, r.top - hr.top + p.y);
  }

  /* --- Image --- */
  var fileInput = $("[data-studio-file]");
  var fileErr = $("[data-studio-file-error]");
  var dropBtn = $("[data-studio-drop]");
  var pickBtn = $("[data-studio-pick]");
  var zoomI = $("[data-studio-zoom]");
  var rotI = $("[data-studio-rotate]");
  var rotVal = $("[data-studio-rotate-val]");
  function showErr(el, msg) { el.textContent = msg || ""; el.hidden = !msg; }
  var GOOD_DPI = 150;
  function fitDpi() {
    if (!state.natural || !SIZES[state.size]) return null;
    var cm = SIZES[state.size];
    return Math.round(Math.min(state.natural.w / (cm[0] / 2.54), state.natural.h / (cm[1] / 2.54)));
  }
  function resMsgEl() {
    var el = $("[data-studio-res-msg]");
    if (!el && fileErr) {
      el = document.createElement("p");
      el.className = "form-error"; el.hidden = true;
      el.setAttribute("data-studio-res-msg", ""); el.setAttribute("data-testid", "studio-resolution-message"); el.setAttribute("role", "status");
      fileErr.parentNode.insertBefore(el, fileErr.nextSibling);
    }
    return el;
  }
  /* La résolution ne bloque jamais la commande : message rassurant, sans jargon (dpi). Chaque photo est relue avant impression. */
  function checkRes() {
    var el = resMsgEl(); if (!el) return true;
    var d = state.file ? fitDpi() : null;
    if (!d || d >= 100) { showErr(el, ""); return true; }
    el.style.color = "#e8d5a3";
    if (d >= 60) {
      showErr(el, CEL_EN ? "Your photo will print well. At " + state.size + " it may look a little soft when seen up close. A smaller size or a larger original would make it sharper, but you can order as is."
        : "Votre photo sera très bien imprimée. En " + state.size + ", elle peut paraître un peu douce vue de très près. Un format plus petit ou un original plus grand la rendrait plus nette, mais vous pouvez commander tel quel.");
      return true;
    }
    showErr(el, CEL_EN ? "This photo is rather small for " + state.size + ". You can still order: we check every photo before printing and will write to you if a better file would improve the result."
      : "Cette photo est assez petite pour un " + state.size + ". Vous pouvez quand même commander : nous relisons chaque photo avant l'impression et nous vous écrivons si un meilleur fichier améliorerait le résultat.");
    return true;
  }

  function loadScript(src) {
    return new Promise(function (res, rej) { var s = document.createElement("script"); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  }
  function imageFromBlob(blob) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(blob), img = new Image();
      img.onload = function () { res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error("decode")); };
      img.src = url;
    });
  }
  function scaled(img, max, type, q) {
    var k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    var c = document.createElement("canvas");
    c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    if (!type) return Promise.resolve({ canvas: c, k: k });
    return new Promise(function (res) { c.toBlob(function (b) { res({ blob: b, k: k }); }, type, q); });
  }
  function heicToImage(file) {
    return imageFromBlob(file).catch(function () {
      return loadScript("https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js").then(function () {
        return window.heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
      }).then(function (b) { return imageFromBlob(Array.isArray(b) ? b[0] : b); });
    });
  }

  function handleFile(file, exampleId) {
    showErr(fileErr, "");
    if (!file) return Promise.resolve();
    state.example = exampleId || null;
    $("[data-studio-example-note]").hidden = !exampleId;
    state.pid = [file.name, file.size, file.lastModified || 0].join("|");
    var name = (file.name || "").toLowerCase();
    var isHeic = /hei[cf]/.test(file.type) || /\.(heic|heif)$/.test(name);
    var ok = /^image\/(jpeg|png)$/.test(file.type) || /\.(jpe?g|png)$/.test(name) || isHeic;
    if (!ok) return Promise.resolve(showErr(fileErr, MSG.type));
    if (file.size > MAX_BYTES) return Promise.resolve(showErr(fileErr, MSG.size));
    pickBtn.disabled = true; pickBtn.textContent = (CEL_EN ? "Opening your photo…" : "Ouverture de votre photo…");
    return (isHeic ? heicToImage(file) : imageFromBlob(file)).then(function (img) {
      state.natural = { w: img.naturalWidth, h: img.naturalHeight };
      if (!isHeic) { state.file = file; return img; }
      return scaled(img, HEIC_MAX, "image/jpeg", 0.92).then(function (r) {
        state.file = new File([r.blob], name.replace(/\.(heic|heif)$/, "") + ".jpg", { type: "image/jpeg" });
        state.natural = { w: Math.round(img.naturalWidth * r.k), h: Math.round(img.naturalHeight * r.k) };
        return img;
      });
    }).then(function (img) {
      var r = scaled(img, DISPLAY_MAX);
      return r.then(function (o) {
        state.displayFactor = o.canvas.width / state.natural.w;
        state.base = o.canvas; state.filtered = { original: o.canvas }; state.filter = "original";
        mark("[data-filter]", "data-filter", "original");
        setPhoto(o.canvas);
      });
    }).catch(function () { showErr(fileErr, MSG.read); }).then(function () {
      pickBtn.disabled = false; pickBtn.textContent = state.file ? (CEL_EN ? "Change photo" : "Changer de photo") : (CEL_EN ? "Upload my photo" : "Importer ma photo");
      checkRes();
    });
  }

  function coverScale() {
    if (!photo) return 1;
    var rad = photo.rotation() * Math.PI / 180, c = Math.abs(Math.cos(rad)), s = Math.abs(Math.sin(rad));
    var bw = photo.width() * c + photo.height() * s, bh = photo.width() * s + photo.height() * c;
    return Math.max(W / bw, H / bh);
  }
  function setPhotoScale(sc) {
    var cv = coverScale();
    sc = Math.max(cv * 0.5, Math.min(cv * 4, sc));
    photo.scale({ x: sc, y: sc });
    zoomI.value = Math.round(sc / cv * 100);
    clampPhoto();
  }
  function clampPhoto() {
    var sc = photo.scaleX(), cv = coverScale();
    if (sc >= cv * 0.999) {
      var hw, hh;
      var rad = photo.rotation() * Math.PI / 180, c = Math.abs(Math.cos(rad)), s = Math.abs(Math.sin(rad));
      hw = (photo.width() * c + photo.height() * s) * sc / 2; hh = (photo.width() * s + photo.height() * c) * sc / 2;
      photo.x(Math.min(hw, Math.max(W - hw, photo.x())));
      photo.y(Math.min(hh, Math.max(H - hh, photo.y())));
    }
    bgLayer.batchDraw();
  }
  function recenter() {
    if (!photo) return;
    photo.position({ x: W / 2, y: H / 2 });
    setPhotoScale(coverScale());
  }
  function setRotation(deg) {
    deg = ((deg + 540) % 360) - 180;
    var rel = photo.scaleX() / coverScale();
    photo.rotation(deg);
    rotI.value = deg; rotVal.textContent = Math.round(deg) + "°";
    setPhotoScale(coverScale() * rel);
  }
  function setPhoto(canvas) {
    if (!photo) {
      photo = new Konva.Image({ image: canvas, draggable: true });
      photoGroup.add(photo);
      photo.on("mousedown touchstart", function () { select(null); });
      photo.on("dragmove", clampPhoto);
    } else photo.image(canvas);
    photo.setAttrs({ width: canvas.width, height: canvas.height, offsetX: canvas.width / 2, offsetY: canvas.height / 2, rotation: 0 });
    rotI.value = 0; rotVal.textContent = "0°";
    recenter();
    if (pendingPhoto) {
      var pp = pendingPhoto;
      pendingPhoto = null;
      setRotation(pp.r || 0);
      setPhotoScale(coverScale() * (pp.z || 1));
      photo.position({ x: pp.x, y: pp.y }); clampPhoto();
      if (pp.fl && pp.fl !== "original") applyFilter(pp.fl);
    }
    dropBtn.hidden = true;
    $("[data-studio-photo-tools]").hidden = false;
    if (!texts.length) addText();
    sparkle();
  }

  pickBtn.addEventListener("click", function () { fileInput.click(); });
  dropBtn.addEventListener("click", function () { fileInput.click(); });
  fileInput.addEventListener("change", function () { handleFile(fileInput.files[0]).then(function () { if (state.file) idbPut(state.pid, state.file); }); fileInput.value = ""; });
  ["dragenter", "dragover"].forEach(function (ev) { frameEl.addEventListener(ev, function (e) { e.preventDefault(); dropBtn.classList.add("is-over"); }); });
  ["dragleave", "drop"].forEach(function (ev) { frameEl.addEventListener(ev, function (e) { e.preventDefault(); dropBtn.classList.remove("is-over"); }); });
  frameEl.addEventListener("drop", function (e) { if (e.dataTransfer && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]); });
  zoomI.addEventListener("input", function () { if (photo) setPhotoScale(coverScale() * zoomI.value / 100); });
  rotI.addEventListener("input", function () { if (photo) setRotation(+rotI.value); });
  $("[data-studio-rot90]").addEventListener("click", function () { if (photo) setRotation(Math.round(photo.rotation() / 90) * 90 + 90); });
  $("[data-studio-recenter]").addEventListener("click", function () { if (photo) { recenter(); sparkle(); } });

  function ramp(l, st) { l = Math.max(0, Math.min(1, l / 255)); for (var k = 1; k < st.length; k++) { if (l <= st[k][0]) { var a = st[k - 1], b = st[k], u = (l - a[0]) / (b[0] - a[0]); return [a[1] + (b[1] - a[1]) * u, a[2] + (b[2] - a[2]) * u, a[3] + (b[3] - a[3]) * u]; } } var z = st[st.length - 1]; return [z[1], z[2], z[3]]; }
  var LOOKF = {
    nuit: function (r, g, b, l) { var o = ramp(l, [[0, 5, 11, 36], [0.5, 36, 58, 122], [1, 207, 224, 255]]); return [o[0] * 0.88 + r * 0.12, o[1] * 0.88 + g * 0.12, o[2] * 0.88 + b * 0.12]; },
    aurore: function (r, g, b, l) { var o = ramp(l, [[0, 8, 24, 52], [0.5, 31, 122, 120], [1, 240, 190, 220]]); return [o[0] * 0.85 + r * 0.15, o[1] * 0.85 + g * 0.15, o[2] * 0.85 + b * 0.15]; },
    cine: function (r, g, b, l) { return l < 128 ? [r * 0.88, g, b * 1.12 + 10] : [r * 1.1 + 8, g, b * 0.86]; },
    pellicule: function (r, g, b, l, i) { var n = (((i * 1103515245 + 12345) >>> 16) & 255) / 255 - 0.5; return [r * 0.92 + 20 + n * 16, g * 0.9 + 16 + n * 16, b * 0.82 + 14 + n * 16]; },
    dore: function (r, g, b) { return [(r * 1.1 + 12 - 128) * 1.05 + 128, (g * 1.03 + 6 - 128) * 1.05 + 128, (b * 0.84 - 128) * 1.05 + 128]; },
    mat: function (r, g, b, l) { return [(r * 0.85 + l * 0.15) * 0.88 + 28, (g * 0.85 + l * 0.15) * 0.88 + 28, (b * 0.85 + l * 0.15) * 0.88 + 28]; },
    contraste: function (r, g, b) { return [(r - 128) * 1.22 + 128, (g - 128) * 1.22 + 128, (b - 128) * 1.22 + 128]; },
    nbfort: function (r, g, b, l) { var v = (l - 128) * 1.35 + 128; return [v, v, v]; }
  };
  function filtered(src, id) {
    var c = document.createElement("canvas");
    c.width = src.width; c.height = src.height;
    var g = c.getContext("2d");
    g.drawImage(src, 0, 0);
    var im = g.getImageData(0, 0, c.width, c.height), d = im.data;
    for (var i = 0; i < d.length; i += 4) {
      var r = d[i], gg = d[i + 1], b = d[i + 2], l = 0.299 * r + 0.587 * gg + 0.114 * b;
      if (id === "nb") { r = gg = b = l; }
      else if (id === "sepia") { r = 0.393 * d[i] + 0.769 * d[i + 1] + 0.189 * d[i + 2]; gg = 0.349 * d[i] + 0.686 * d[i + 1] + 0.168 * d[i + 2]; b = 0.272 * d[i] + 0.534 * d[i + 1] + 0.131 * d[i + 2]; }
      else if (id === "chaud") { r = r * 1.08 + 12; gg = gg * 1.02 + 4; b = b * 0.88; }
      else if (id === "froid") { r = r * 0.9; gg = gg * 0.98 + 4; b = b * 1.08 + 14; }
      else if (id === "doux") { r = (r * 0.85 + l * 0.15) * 0.86 + 32; gg = (gg * 0.85 + l * 0.15) * 0.86 + 32; b = (b * 0.85 + l * 0.15) * 0.86 + 32; }
      if (LOOKF[id]) { var o2 = LOOKF[id](d[i], d[i + 1], d[i + 2], l, i); r = o2[0]; gg = o2[1]; b = o2[2]; }
      d[i] = r; d[i + 1] = gg; d[i + 2] = b;
    }
    g.putImageData(im, 0, 0);
    return c;
  }
  var filterBox = $("[data-studio-filters]");
  FILTERS.forEach(function (f) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "studio__chip" + (f.id === "original" ? " is-selected" : ""); b.textContent = f.label;
    b.dataset.filter = f.id; b.setAttribute("data-testid", "studio-filter-" + f.id);
    b.addEventListener("click", function () { if (photo) { applyFilter(f.id); sparkle(); } });
    filterBox.appendChild(b);
  });
  function applyFilter(id) {
    state.filter = id;
    if (!state.filtered[id]) state.filtered[id] = filtered(state.base, id);
    photo.image(state.filtered[id]); bgLayer.batchDraw();
    mark("[data-filter]", "data-filter", id);
  }

  function isText(n) { return n instanceof Konva.Text; }
  function sizeOf(n) { return isText(n) ? n.fontSize() : n.scaleX(); }
  function resizeNode(n, v) {
    if (isText(n)) { n.fontSize(Math.max(12, Math.min(260, v))); center(n); applyFx(n); syncEditor(); }
    else { v = Math.max(0.15, Math.min(6, v)); n.scale({ x: v, y: v }); textLayer.batchDraw(); }
  }
  stage.on("wheel", function (e) {
    var target = selected || photo;
    if (!target) return;
    e.evt.preventDefault();
    var k = e.evt.deltaY > 0 ? 0.95 : 1.05;
    if (target === photo) setPhotoScale(photo.scaleX() * k);
    else resizeNode(target, sizeOf(target) * k);
  });

  var pinch = null;
  stage.on("touchmove", function (e) {
    var t = e.evt.touches;
    if (!t || t.length !== 2) { pinch = null; return; }
    e.evt.preventDefault();
    var target = selected || photo;
    if (!target) return;
    var dx = t[1].clientX - t[0].clientX, dy = t[1].clientY - t[0].clientY;
    var d = Math.sqrt(dx * dx + dy * dy), a = Math.atan2(dy, dx) * 180 / Math.PI;
    if (!pinch) {
      if (target.isDragging()) target.stopDrag();
      pinch = { d: d, a: a, s: target === photo ? photo.scaleX() : sizeOf(target), r: target.rotation() };
      return;
    }
    var k = d / pinch.d;
    if (target === photo) {
      photo.rotation(pinch.r + a - pinch.a); rotI.value = Math.round(((photo.rotation() + 540) % 360) - 180); rotVal.textContent = rotI.value + "°";
      setPhotoScale(pinch.s * k);
    } else {
      target.rotation(pinch.r + a - pinch.a); resizeNode(target, pinch.s * k);
    }
    stage.batchDraw();
  });
  stage.on("touchend", function () { pinch = null; });
  stage.on("click tap", function (e) { if (e.target === stage || e.target === paper) select(null); });

  /* --- Textes --- */
  var editor = $("[data-studio-editor]");
  var textI = $("[data-studio-text]");
  var sizeI = $("[data-studio-size]");
  var lhI = $("[data-studio-lh]");
  var lsI = $("[data-studio-ls]");
  var haloBox = $("[data-studio-halo]");
  var haloInt = $("[data-studio-halo-int]");
  var haloColor = $("[data-studio-halo-color]");
  var strokeI = $("[data-studio-stroke]");
  var strokeColor = $("[data-studio-stroke-color]");
  var opacityI = $("[data-studio-opacity]");
  var addBtn = $("[data-studio-add-text]");
  var list = $("[data-studio-text-list]");
  var fontsBox = $("[data-studio-fonts]");
  var colorsBox = $("[data-studio-colors]");

  FONTS.forEach(function (f) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "studio__font"; b.textContent = f.label; b.style.fontFamily = '"' + f.fam + '"';
    b.dataset.font = f.id; b.setAttribute("data-testid", "studio-font-" + f.id);
    b.addEventListener("click", function () { if (selected && isText(selected)) { selected.setAttr("fontId", f.id); selected.fontFamily(f.fam); display(selected); syncEditor(); } });
    fontsBox.appendChild(b);
  });
  COLORS.forEach(function (c, i) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "studio__swatch"; b.style.background = c.c; b.title = c.n; b.setAttribute("aria-label", c.n);
    b.dataset.color = c.c; b.setAttribute("data-testid", "studio-color-" + i);
    b.addEventListener("click", function () { setProp("fill", c.c); });
    colorsBox.appendChild(b);
    var o = b.cloneNode(true);
    o.className = "studio__swatch studio__swatch--orn"; o.setAttribute("data-testid", "studio-orn-color-" + i);
    o.addEventListener("click", function () { setOrnColor(c.c); });
    $("[data-studio-orn-colors]").appendChild(o);
  });
  var freeColor = document.createElement("input");
  freeColor.type = "color"; freeColor.className = "studio__picker"; freeColor.setAttribute("aria-label", "Couleur libre"); freeColor.setAttribute("data-testid", "studio-color-free");
  freeColor.addEventListener("input", function () { setProp("fill", freeColor.value); });
  colorsBox.appendChild(freeColor);

  function fontById(id) { for (var i = 0; i < FONTS.length; i++) if (FONTS[i].id === id) return FONTS[i]; return FONTS[0]; }
  function center(t) { t.offsetX(t.width() / 2); t.offsetY(t.height() / 2); textLayer.batchDraw(); }
  function display(t) {
    var raw = t.getAttr("raw") || " ", m = t.getAttr("caseMode");
    t.text(m === "upper" ? raw.toLocaleUpperCase("fr") : m === "lower" ? raw.toLocaleLowerCase("fr") : raw);
    center(t);
    if (t.getAttr("fx")) applyFx(t);
  }
  function applyFx(t) {
    var fx = t.getAttr("fx");
    if (fx.effect === "eclat") {
      t.setAttrs({ fillPriority: "linear-gradient", fillLinearGradientStartPoint: { x: 0, y: 0 }, fillLinearGradientEndPoint: { x: t.width() * 0.25, y: t.height() },
        fillLinearGradientColorStops: METALS[fx.metal] || METALS.or });
    } else t.fillPriority("color");
    if (fx.effect === "eclat") t.setAttrs({ shadowEnabled: true, shadowColor: "#000000", shadowBlur: 6, shadowOffset: { x: 1, y: 2 }, shadowOpacity: 0.45 });
    else if (fx.effect === "halo") t.setAttrs({ shadowEnabled: true, shadowColor: fx.haloColor, shadowBlur: 4 + fx.haloInt * 0.6, shadowOffset: { x: 0, y: 0 }, shadowOpacity: Math.min(1, 0.4 + fx.haloInt / 160) });
    else if (fx.effect === "voile") t.setAttrs({ shadowEnabled: true, shadowColor: "#000000", shadowBlur: 14, shadowOffset: { x: 5, y: 7 }, shadowOpacity: 0.5 });
    else if (fx.effect === "relief") t.setAttrs({ shadowEnabled: true, shadowColor: "#000000", shadowBlur: 1.5, shadowOffset: { x: 2, y: 3 }, shadowOpacity: 0.75 });
    else if (fx.effect === "neon") t.setAttrs({ shadowEnabled: true, shadowColor: fx.haloColor, shadowBlur: 26, shadowOffset: { x: 0, y: 0 }, shadowOpacity: 1 });
    else t.shadowEnabled(false);
    t.setAttrs({ stroke: fx.stroke ? fx.strokeColor : null, strokeWidth: fx.stroke ? Math.max(1.2, t.fontSize() / 40) : 0, fillAfterStrokeEnabled: true, opacity: fx.opacity / 100 });
    textLayer.batchDraw();
  }
  function setProp(k, v) { if (!selected || !isText(selected)) return; selected.setAttr(k, v); center(selected); applyFx(selected); syncEditor(); }
  function setFx(k, v) { if (!selected || !isText(selected)) return; selected.getAttr("fx")[k] = v; applyFx(selected); syncEditor(); }

  function addText(spec) {
    if (texts.length >= 4) return;
    spec = spec || {};
    var n = texts.length, f = fontById(spec.font || FONTS[0].id);
    var t = new Konva.Text({
      x: W / 2, y: spec.y != null ? H * spec.y : H * (0.78 - 0.12 * n), fontFamily: f.fam, fontSize: spec.size || (n ? 46 : 72), fill: spec.color || "#F6F1E4",
      align: "center", lineHeight: 1.15, letterSpacing: spec.ls || 0, draggable: true
    });
    t.setAttrs({ raw: spec.raw || (n ? (CEL_EN ? "A moment of ours" : "Un instant à nous") : (CEL_EN ? "Your memory" : "Votre souvenir")), caseMode: spec.caseMode || "none", fontId: f.id,
      fx: { effect: spec.effect || "voile", haloColor: spec.haloColor || "#D8BE84", haloInt: 45, metal: spec.metal || "or", stroke: false, strokeColor: "#15151A", opacity: 100 } });
    display(t);
    textLayer.add(t); tr.moveToTop(); texts.push(t);
    t.on("mousedown touchstart", function () { select(t); });
    t.on("dragend", function () { sparkleNode(t); });
    t.on("transform", function () {
      var s = t.scaleX();
      t.setAttrs({ fontSize: Math.max(12, Math.min(260, t.fontSize() * s)), scaleX: 1, scaleY: 1 });
      center(t); applyFx(t); syncEditor();
    });
    t.on("transformend", function () { sparkleNode(t); });
    select(t);
    sparkleNode(t);
  }
  function removeSelected() {
    if (!selected) return;
    var arr = isText(selected) ? texts : orns;
    arr.splice(arr.indexOf(selected), 1);
    selected.destroy(); select(null);
  }

  function addOrnament(type, spec) {
    if (orns.length >= 8) return;
    spec = spec || {};
    var color = spec.color || "#D8BE84", s = spec.s || 1.3;
    var n = orns.length;
    var g = new Konva.Group({ x: W * (spec.x != null ? spec.x : 0.5 + ((n % 3) - 1) * 0.18), y: H * (spec.y != null ? spec.y : 0.22 + Math.floor(n / 3) * 0.08), offsetX: 50, offsetY: 50, scaleX: s, scaleY: s, draggable: true });
    g.add(new Konva.Rect({ width: 100, height: 100, fill: "rgba(0,0,0,0)" }));
    ORN[type].parts.forEach(function (p) {
      g.add(new Konva.Path({ data: p.d, fill: p.stroke ? null : color, stroke: p.stroke ? color : null, strokeWidth: p.stroke || 0, lineCap: "round", lineJoin: "round",
        isStroke: !!p.stroke, shadowColor: color, shadowBlur: 10, shadowOpacity: 0.55 }));
    });
    g.setAttrs({ ornType: type, color: color });
    textLayer.add(g); tr.moveToTop(); orns.push(g);
    g.on("mousedown touchstart", function () { select(g); });
    g.on("dragend transformend", function () { sparkleNode(g); });
    if (!spec.silent) { select(g); sparkleNode(g); }
  }
  function setOrnColor(c) {
    if (!selected || isText(selected)) return;
    selected.setAttr("color", c);
    selected.find("Path").forEach(function (p) { if (p.getAttr("isStroke")) p.stroke(c); else p.fill(c); p.shadowColor(c); });
    textLayer.batchDraw(); syncEditor();
  }
  function clearAll() {
    texts.concat(orns).forEach(function (n) { n.destroy(); });
    texts.length = 0; orns.length = 0; select(null);
  }
  function applyTemplate(id) {
    var tp = TEMPLATES[id];
    clearAll();
    tp.texts.forEach(function (s) { addText(s); });
    tp.orn.forEach(function (o) { addOrnament(o.type, { x: o.x, y: o.y, s: o.s, color: o.color, silent: true }); });
    select(texts[0]);
    mark("[data-template]", "data-template", id);
    sparkle();
  }
  function fitSafe(t) {
    var max = W * 0.88;
    if (t.width() > max) { t.fontSize(Math.max(12, t.fontSize() * max / t.width())); center(t); applyFx(t); }
  }
  var inspireIdx = -1;
  function inspire() {
    if (!texts.length) addText();
    inspireIdx = (inspireIdx + 1 + Math.floor(Math.random() * (INSPIRE.length - 1))) % INSPIRE.length;
    var c = INSPIRE[inspireIdx];
    var targets = texts;
    targets.forEach(function (t, i) {
      var main = i === 0, f = fontById(main ? c.font : "epure-legere"), fx = t.getAttr("fx");
      t.setAttrs({ fontFamily: f.fam, fontId: f.id, fill: main ? c.color : "#F6F1E4", letterSpacing: main ? (c.ls || 0) : 5, caseMode: main ? (c.caseMode || "none") : "upper" });
      fx.effect = main ? c.effect : (c.effect === "eclat" ? "eclat" : "voile");
      if (c.haloColor) fx.haloColor = c.haloColor;
      if (c.metal) fx.metal = c.metal;
      display(t); fitSafe(t); sparkleNode(t);
    });
    syncEditor();
  }
  function select(t) {
    selected = t;
    tr.nodes(t ? [t] : []);
    textLayer.batchDraw();
    syncEditor();
  }
  function renderList() {
    list.innerHTML = "";
    texts.forEach(function (t, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "studio__chip" + (t === selected ? " is-selected" : "");
      b.textContent = (i + 1) + " · " + (t.getAttr("raw") || "").split("\n")[0];
      b.setAttribute("data-testid", "studio-text-chip-" + i);
      b.addEventListener("click", function () { select(t); });
      list.appendChild(b);
    });
    $("[data-studio-text-count]").textContent = texts.length + " / 4";
    addBtn.disabled = texts.length >= 4;
    $("[data-studio-text-empty]").hidden = !!selected;
  }
  function mark(sel, attr, val) { $$(sel).forEach(function (b) { b.classList.toggle("is-selected", b.getAttribute(attr) === val); }); }
  function syncEditor() {
    renderList();
    editor.hidden = !selected || !isText(selected);
    ornEditor.hidden = !selected || isText(selected);
    $("[data-studio-orn-count]").textContent = orns.length + " / 8";
    if (!selected) return;
    if (!isText(selected)) { mark(".studio__swatch--orn", "data-color", selected.getAttr("color")); return; }
    var t = selected, fx = t.getAttr("fx");
    if (document.activeElement !== textI) textI.value = t.getAttr("raw");
    sizeI.value = Math.round(t.fontSize());
    lhI.value = Math.round(t.lineHeight() * 100);
    lsI.value = Math.round(t.letterSpacing());
    mark(".studio__font", "data-font", t.getAttr("fontId"));
    mark(".studio__swatch", "data-color", t.fill());
    mark("[data-align]", "data-align", t.align());
    mark("[data-case]", "data-case", t.getAttr("caseMode"));
    mark("[data-effect]", "data-effect", fx.effect);
    mark("[data-metal]", "data-metal", fx.metal);
    $("[data-studio-metal]").hidden = fx.effect !== "eclat";
    haloBox.hidden = fx.effect !== "halo" && fx.effect !== "neon";
    haloInt.value = fx.haloInt; haloColor.value = fx.haloColor;
    strokeI.checked = fx.stroke; strokeColor.value = fx.strokeColor;
    opacityI.value = fx.opacity;
  }

  var ornEditor = $("[data-studio-orn-editor]");
  addBtn.addEventListener("click", function () { addText(); });
  $("[data-studio-remove]").addEventListener("click", removeSelected);
  $("[data-studio-orn-remove]").addEventListener("click", removeSelected);
  $("[data-studio-inspire]").addEventListener("click", inspire);
  $$("[data-template]").forEach(function (b) { b.addEventListener("click", function () { applyTemplate(b.dataset.template); }); });
  $$("[data-metal]").forEach(function (b) { b.addEventListener("click", function () { setFx("metal", b.dataset.metal); }); });
  Object.keys(ORN).forEach(function (k) {
    var b = document.createElement("button");
    b.type = "button"; b.className = "studio__orn"; b.title = ORN[k].label; b.setAttribute("aria-label", ORN[k].label);
    b.setAttribute("data-testid", "studio-orn-" + k);
    b.innerHTML = '<svg viewBox="0 0 100 100" width="30" height="30">' + ORN[k].parts.map(function (p) {
      return '<path d="' + p.d + '" fill="' + (p.stroke ? "none" : "currentColor") + '" stroke="' + (p.stroke ? "currentColor" : "none") + '" stroke-width="' + (p.stroke ? p.stroke * 1.6 : 0) + '" stroke-linecap="round"/>';
    }).join("") + "</svg>";
    b.addEventListener("click", function () { addOrnament(k); });
    $("[data-studio-orns]").appendChild(b);
  });
  textI.addEventListener("input", function () { if (selected) { selected.setAttr("raw", textI.value); display(selected); renderList(); } });
  sizeI.addEventListener("input", function () { if (selected) { selected.fontSize(+sizeI.value); center(selected); applyFx(selected); } });
  lhI.addEventListener("input", function () { setProp("lineHeight", lhI.value / 100); });
  lsI.addEventListener("input", function () { setProp("letterSpacing", +lsI.value); });
  $$("[data-align]").forEach(function (b) { b.addEventListener("click", function () { setProp("align", b.dataset.align); }); });
  $$("[data-case]").forEach(function (b) { b.addEventListener("click", function () { if (selected) { selected.setAttr("caseMode", b.dataset["case"]); display(selected); syncEditor(); } }); });
  $$("[data-effect]").forEach(function (b) { b.addEventListener("click", function () { setFx("effect", b.dataset.effect); if (selected) sparkleNode(selected); }); });
  haloInt.addEventListener("input", function () { setFx("haloInt", +haloInt.value); });
  haloColor.addEventListener("input", function () { setFx("haloColor", haloColor.value); });
  strokeI.addEventListener("change", function () { setFx("stroke", strokeI.checked); });
  strokeColor.addEventListener("input", function () { setFx("strokeColor", strokeColor.value); });
  opacityI.addEventListener("input", function () { setFx("opacity", +opacityI.value); });

  if (document.fonts && document.fonts.load) {
    Promise.all(FONTS.map(function (f) { return document.fonts.load('48px "' + f.fam + '"'); })).then(function () {
      texts.forEach(function (t) { t._setTextData(); center(t); });
      textLayer.batchDraw();
    });
  }

  /* --- Taille, cadre, prix --- */
  var priceEl = $("[data-studio-price]");
  var orderLabel = $("[data-studio-order-label]");
  function variant() {
    if (state.support === "poster") {
      /* « 21 × 30 cm » du cadre correspond à l'A4 (21 × 29,7 cm) du poster seul */
      var P = window.STUDIO_POSTER_VARIANTS || [], want = state.size === "21 × 30 cm" ? "21 × 29,7" : state.size;
      for (var j = 0; j < P.length; j++) if (P[j].option1 === want || P[j].option1.indexOf(want + " ") === 0) return P[j];
      return null;
    }
    var V = window.STUDIO_VARIANTS || [];
    for (var i = 0; i < V.length; i++) if (V[i].option1 === state.size && V[i].option2 === FRAME_NAMES[state.frame]) return V[i];
    return null;
  }
  function money(c) { return (c / 100).toLocaleString(((window.CELESTIAR_I18N||{}).locale === "en") ? "en-IE" : "fr-FR", { style: "currency", currency: "EUR" }); }
  function updatePrice() {
    var v = variant();
    var p = v ? money(v.price) : "[indisponible]";
    priceEl.textContent = p;
    var poster = state.support === "poster";
    orderLabel.textContent = (poster ? (CEL_EN ? "Order my poster — " : "Commander mon poster — ") : (CEL_EN ? "Order my frame — " : "Commander mon cadre — ")) + p;
    $("[data-studio-price-label]").textContent = poster ? (CEL_EN ? "Your poster:" : "Votre poster :") : (CEL_EN ? "Your frame:" : "Votre cadre :");
  }
  function setSize(label) {
    var ratio = (W * SIZES[label][1] / SIZES[label][0]) / H;
    state.size = label; H = W * SIZES[label][1] / SIZES[label][0];
    checkRes();
    paper.height(H); drawMat(); applyLook();
    texts.concat(orns).forEach(function (t) { t.y(t.y() * ratio); });
    if (photo) { photo.y(photo.y() * ratio); if (photo.scaleX() < coverScale()) setPhotoScale(coverScale()); else setPhotoScale(photo.scaleX()); }
    updateSafety(); fit(); updatePrice(); updateRoom();
  }
  $$("[data-studio-sizes] [data-size]").forEach(function (b) {
    b.addEventListener("click", function () { mark("[data-studio-sizes] [data-size]", "data-size", b.dataset.size); setSize(b.dataset.size); sparkle(); });
  });
  $$("[data-studio-mat]").forEach(function (b) { b.addEventListener("click", function () { setMat(b.getAttribute("data-studio-mat")); sparkle(); }); });
  $$("[data-studio-matcolor]").forEach(function (b) { b.addEventListener("click", function () { setMat(null, b.getAttribute("data-studio-matcolor")); }); });
  function setFrame(id) {
    state.frame = id;
    mark("[data-studio-frames] [data-frame]", "data-frame", id);
    var shown = state.support !== "cadre" ? "aucun" : id;
    frameEl.dataset.frame = shown; $("[data-room-frame]").dataset.frame = shown;
    updatePrice();
  }
  var framesWrap = $("[data-studio-frames-wrap]");
  $$("[data-studio-supports] [data-support]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.support = b.dataset.support;
      var poster = state.support === "poster";
      mark("[data-studio-supports] [data-support]", "data-support", state.support);
      framesWrap.hidden = poster;
      $$("[data-studio-sizes] [data-size]").forEach(function (x) {
        var only = x.hasAttribute("data-poster-only");
        x.hidden = only ? !poster : false;
      });
      var curb = $('[data-studio-sizes] [data-size="' + state.size + '"]');
      if (curb && curb.hidden) { mark("[data-studio-sizes] [data-size]", "data-size", "30 × 40 cm"); setSize("30 × 40 cm"); }
      setFrame(state.frame); fit(); updateRoom(); sparkle();
    });
  });
  $$("[data-studio-frames] [data-frame]").forEach(function (b) {
    b.addEventListener("click", function () { setFrame(b.dataset.frame); sparkle(); });
  });
  (function oak() {
    var V = window.STUDIO_VARIANTS || [], base = null, ch = null;
    V.forEach(function (v) { if (v.option1 === "13 × 18 cm") { if (v.option2 === "Chêne") ch = v.price; else if (base == null) base = v.price; } });
    if (base != null && ch != null) $("[data-studio-oak]").textContent = "+" + money(ch - base);
  })();

  /* --- Vue « Dans une pièce » --- */
  var room = $("[data-studio-room]");
  var roomFrame = $("[data-room-frame]");
  function exportCanvas(width) {
    var t = tr.nodes(); tr.nodes([]); safety.visible(false);
    var c = stage.toCanvas({ pixelRatio: width / stage.width() });
    safety.visible(true); tr.nodes(t); stage.batchDraw();
    return c;
  }
  window.celestiarStudioSnapshot = function (w) { return exportCanvas(w || 1000); };
  function updateRoom() {
    if (room.hidden) return;
    roomFrame.style.width = ROOM_WIDTH[state.size] + "%";
    roomFrame.querySelector("img").src = exportCanvas(700).toDataURL("image/jpeg", 0.85);
  }
  $$("[data-view]").forEach(function (b) {
    b.addEventListener("click", function () {
      var piece = b.dataset.view === "piece";
      mark("[data-view]", "data-view", b.dataset.view);
      $$("[data-view]").forEach(function (x) { x.classList.toggle("is-active", x === b); });
      room.hidden = !piece; holder.hidden = piece;
      if (piece) updateRoom(); else fit();
    });
  });

  /* --- Commande --- */
  var orderBtn = $("[data-studio-order]");
  var orderErr = $("[data-studio-order-error]");
  var chkText = $("[data-studio-check-text]");
  var chkRights = $("[data-studio-check-rights]");
  function dpi() {
    if (!photo || !state.natural) return null;
    var unitsPerPx = photo.scaleX() * state.displayFactor;
    return Math.round((W / unitsPerPx) / (SIZES[state.size][0] / 2.54));
  }
  function config() {
    var r = function (n) { return Math.round(n * 10) / 10; };
    return {
      version: 1, exemple: state.example || null, format: state.size, cadre: state.support === "poster" ? "Poster seul (sans cadre)" : FRAME_NAMES[state.frame], repere: { largeur: W, hauteur: r(H), note: "coordonnées en unités, largeur du visuel = 1000" },
      photo: photo ? { fichier: state.file && state.file.name, largeurPx: state.natural.w, hauteurPx: state.natural.h, x: r(photo.x()), y: r(photo.y()),
        echelleOriginal: Math.round(photo.scaleX() * state.displayFactor * 100000) / 100000, rotation: r(photo.rotation()), dpiEstime: dpi() } : null,
      textes: texts.map(function (t) {
        var fx = t.getAttr("fx");
        return { texte: t.getAttr("raw"), affiche: t.text(), style: fontById(t.getAttr("fontId")).label, police: t.fontFamily().replace("SC ", ""),
          taille: r(t.fontSize()), couleur: t.fill(), alignement: t.align(), interligne: t.lineHeight(), espacement: t.letterSpacing(), casse: t.getAttr("caseMode"),
          effet: fx.effect, halo: fx.effect === "halo" ? { couleur: fx.haloColor, intensite: fx.haloInt } : null, contour: fx.stroke ? fx.strokeColor : null,
          eclat: fx.effect === "eclat" ? fx.metal : null, opacite: fx.opacity, x: r(t.x()), y: r(t.y()), rotation: r(t.rotation()) };
      }),
      passepartout: mat.type === "aucun" ? null : { type: MAT_NAMES[mat.type], couleur: mat.color },
      filtre: state.filter,
      miseEnForme: { forme: look.shape, marge: look.margin, papier: PAPERS[look.paper][1], filet: look.line, styleFilet: look.lineStyle, voile: look.veil, intensiteVoile: look.veilInt },
      ornements: orns.map(function (o) {
        return { type: o.getAttr("ornType"), couleur: o.getAttr("color"), x: r(o.x()), y: r(o.y()), taille: r(100 * o.scaleX()), rotation: r(o.rotation()) };
      })
    };
  }
  function toast(msg) {
    var el = document.createElement("div");
    el.className = "studio__toast"; el.textContent = msg; el.setAttribute("data-testid", "studio-toast");
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2600);
  }
  orderBtn.addEventListener("click", function () {
    showErr(orderErr, "");
    if (!photo || !state.file) return showErr(orderErr, MSG.noPhoto);
    if (!chkText.checked || !chkRights.checked) return showErr(orderErr, MSG.checks);
    if (!checkRes()) return showErr(orderErr, $("[data-studio-res-msg]").textContent);
    var v = variant();
    if (!v || v.available === false) return showErr(orderErr, MSG.variant);
    select(null);
    orderBtn.disabled = true;
    var original = orderLabel.textContent;
    orderLabel.textContent = state.support === "poster" ? (CEL_EN ? "Preparing your poster…" : "Préparation de votre poster…") : (CEL_EN ? "Preparing your frame…" : "Préparation de votre cadre…");
    var d = dpi();
    new Promise(function (res) { exportCanvas(1600).toBlob(res, "image/jpeg", 0.9); }).then(function (preview) {
      var words = texts.map(function (t) { return t.getAttr("raw").replace(/\s+/g, " ").trim(); }).filter(Boolean).join(" · ");
      var fd = new FormData();
      fd.append("form_type", "product");
      fd.append("id", String(v.id));
      fd.append("quantity", "1");
      fd.append("properties[Création]", "Studio Céleste");
      fd.append("properties[Passe-partout]", mat.type === "aucun" ? "Aucun" : MAT_NAMES[mat.type] + " " + mat.color);
      fd.append("properties[Support]", state.support === "poster" ? "Poster seul (sans cadre)" : "Cadre " + FRAME_NAMES[state.frame]);
      fd.append("properties[Vos mots]", words || "—");
      fd.append("properties[Relecture]", "Confirmée");
      fd.append("properties[Droits sur l'image]", "Confirmés");
      fd.append("properties[Photo utilisée]", state.example ? "Photo d'exemple Celestiar (galerie : " + state.example + ")" : "Photo importée par le client");
      fd.append("properties[Photo du client]", state.file, state.file.name || "photo.jpg");
      fd.append("properties[_Aperçu de la création]", preview, "apercu-studio-celeste.jpg");
      fd.append("properties[_Configuration]", JSON.stringify(config()));
      fd.append("properties[_Résolution estimée]", d ? "≈ " + d + " dpi" : "—");
      if (d && d < 150) fd.append("properties[_Alerte résolution]", "Image faible pour " + state.size + " : ≈ " + d + " dpi (150 dpi minimum conseillé)");
      fd.append("properties[_Source photo]", state.example ? "exemple:" + state.example : "client:" + (state.file.name || ""));
      fd.append("properties[_origine]", "studio-celeste");
      return fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" } });
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      return r.json();
    }).then(function () {
      toast(MSG.added); sparkle();
      setTimeout(function () { window.location.href = ((window.CELESTIAR_I18N||{}).root||"/").replace(/\/$/,"") + "/cart"; }, 1500);
    }).catch(function () {
      showErr(orderErr, MSG.cart);
      orderBtn.disabled = false;
      orderLabel.textContent = original;
    });
  });

  /* --- Enregistrer ma création / galerie --- */
  var pendingPhoto = null;
  var EX_TEXT = { naissance: ["#1C2547", "#7A5A22"] };
  function idbOpen() {
    return new Promise(function (res, rej) {
      if (!window.indexedDB) return rej(new Error("idb"));
      var q = indexedDB.open("studio-celeste", 1);
      q.onupgradeneeded = function () { q.result.createObjectStore("photos"); };
      q.onsuccess = function () { res(q.result); };
      q.onerror = rej;
    });
  }
  function idbPut(key, file) {
    return idbOpen().then(function (db) {
      return new Promise(function (res) {
        var tx = db.transaction("photos", "readwrite");
        tx.objectStore("photos").put({ blob: file, name: file.name, type: file.type }, key);
        tx.oncomplete = res; tx.onerror = res;
      });
    }).catch(function () {});
  }
  function idbGet(key) {
    return idbOpen().then(function (db) {
      return new Promise(function (res) {
        var q = db.transaction("photos").objectStore("photos").get(key);
        q.onsuccess = function () { res(q.result || null); }; q.onerror = function () { res(null); };
      });
    }).catch(function () { return null; });
  }
  function enc(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); }
  function dec(s) { return JSON.parse(decodeURIComponent(escape(atob(s.replace(/-/g, "+").replace(/_/g, "/"))))); }
  function snapshot() {
    var r = function (n) { return Math.round(n * 10) / 10; };
    return {
      v: 1, s: state.size, f: state.frame, sp: state.support, mt: mat.type, mc: mat.color, lk: JSON.parse(JSON.stringify(look)), fl: state.filter, ex: state.example || null, pid: state.example ? null : state.pid || null,
      p: photo ? { x: r(photo.x()), y: r(photo.y()), z: Math.round(photo.scaleX() / coverScale() * 1000) / 1000, r: r(photo.rotation()) } : null,
      t: texts.map(function (t) {
        var fx = t.getAttr("fx");
        return { r: t.getAttr("raw"), f: t.getAttr("fontId"), z: r(t.fontSize()), c: t.fill(), a: t.align(), lh: t.lineHeight(), ls: t.letterSpacing(), k: t.getAttr("caseMode"),
          e: fx.effect, hc: fx.haloColor, hi: fx.haloInt, m: fx.metal, st: fx.stroke ? fx.strokeColor : 0, op: fx.opacity, x: r(t.x()), y: r(t.y()), ro: r(t.rotation()) };
      }),
      o: orns.map(function (o) { return { t: o.getAttr("ornType"), c: o.getAttr("color"), x: r(o.x()), y: r(o.y()), s: Math.round(o.scaleX() * 1000) / 1000, ro: r(o.rotation()) }; })
    };
  }
  function restore(sn) {
    clearAll();
    var sup = $('[data-studio-supports] [data-support="' + (sn.sp === "poster" ? "poster" : "cadre") + '"]');
    if (sup && sn.sp === "poster") sup.click();
    if (sn.mt && MATS.hasOwnProperty(sn.mt)) setMat(sn.mt, sn.mc);
    setLook(sn.lk || { shape: "rect", margin: 9, paper: "ivoire", line: "aucun", lineStyle: "fin", veil: "aucun", veilInt: 60 });
    if (SIZES[sn.s]) { mark("[data-studio-sizes] [data-size]", "data-size", sn.s); setSize(sn.s); }
    if (FRAME_NAMES[sn.f]) setFrame(sn.f);
    (sn.t || []).forEach(function (d) {
      addText({ raw: d.r, font: d.f, size: d.z, color: d.c, ls: d.ls, caseMode: d.k, effect: d.e, haloColor: d.hc, metal: d.m });
      var t = texts[texts.length - 1], fx = t.getAttr("fx");
      t.setAttrs({ x: d.x, y: d.y, rotation: d.ro || 0, align: d.a || "center", lineHeight: d.lh || 1.15 });
      fx.haloInt = d.hi || 45; fx.stroke = !!d.st; if (d.st) fx.strokeColor = d.st; fx.opacity = d.op || 100;
      display(t);
    });
    (sn.o || []).forEach(function (d) {
      if (!ORN[d.t]) return;
      addOrnament(d.t, { color: d.c, s: d.s, silent: true });
      orns[orns.length - 1].setAttrs({ x: d.x, y: d.y, rotation: d.ro || 0 });
    });
    select(null);
    pendingPhoto = sn.p ? { x: sn.p.x, y: sn.p.y, z: sn.p.z, r: sn.p.r, fl: sn.fl } : null;
    if (sn.ex) return loadExamplePhoto(sn.ex);
    if (!sn.p) return Promise.resolve();
    return idbGet(sn.pid).then(function (rec) {
      if (rec) return handleFile(new File([rec.blob], rec.name, { type: rec.type }));
      dropBtn.querySelector("strong").textContent = (CEL_EN ? "Upload your photo to restore your creation" : "Importez votre photo pour retrouver votre création");
    });
  }
  function exampleUrl(id) { var c = root.querySelector('[data-example="' + id + '"]'); return c && c.dataset.photo; }
  function loadExamplePhoto(id) {
    var url = exampleUrl(id);
    if (!url) return Promise.resolve();
    return fetch(url).then(function (r) { return r.blob(); }).then(function (b) {
      return handleFile(new File([b], "exemple-" + id + ".jpg", { type: "image/jpeg" }), id);
    });
  }
  function loadExample(id) {
    var keep = texts.length;
    var own = photo && state.file && !state.example;
    return (own ? Promise.resolve() : loadExamplePhoto(id)).then(function () {
      if (!TEMPLATES[id]) return;
      applyTemplate(id);
      (EX_TEXT[id] || []).forEach(function (c, i) { var t = texts[i]; if (!t) return; t.fill(c); t.getAttr("fx").effect = "none"; applyFx(t); });
      syncEditor();
      return keep;
    });
  }
  $$("[data-example]").forEach(function (card) {
    card.addEventListener("click", function () {
      loadExample(card.dataset.example).then(function () {
        root.querySelector(".studio__grid").scrollIntoView({ behavior: "smooth", block: "start" });
        showErr(fileErr, "");
        $("[data-studio-example-note]").hidden = !state.example;
      });
    });
  });

  var saveNote = $("[data-studio-save-note]");
  function saveUrl() {
    var sn = snapshot();
    if (state.file && !state.example) idbPut(state.pid, state.file);
    var url = location.origin + location.pathname + "#creation=" + enc(sn);
    history.replaceState(null, "", url);
    return url;
  }
  function saveMsg() {
    return !photo || state.example ? (CEL_EN ? "Link copied ✦ Keep it to come back to your frame whenever you like." : "Lien copié ✦ Gardez-le pour reprendre votre cadre quand vous le souhaitez.")
      : (CEL_EN ? "Link copied ✦ On this device your photo will be restored. On another device, simply upload it again." : "Lien copié ✦ Sur cet appareil, votre photo sera retrouvée. Sur un autre appareil, il suffira de la réimporter.");
  }
  $("[data-studio-save]").addEventListener("click", function () {
    var url = saveUrl();
    var input = $("[data-studio-save-url]");
    input.value = url;
    (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      saveNote.textContent = saveMsg(); input.hidden = true;
    }).catch(function () {
      saveNote.textContent = (CEL_EN ? "Copy this link to find your creation again:" : "Copiez ce lien pour retrouver votre création :"); input.hidden = false; input.select();
    }).then(function () { saveNote.hidden = false; sparkle(); });
  });
  var shareBtn = $("[data-studio-share]");
  if (navigator.share) {
    shareBtn.hidden = false;
    shareBtn.addEventListener("click", function () {
      navigator.share({ title: (CEL_EN ? "My Studio Céleste creation" : "Ma création Studio Céleste"), text: (CEL_EN ? "Look at the frame I'm designing on Celestiar ✦" : "Regardez le cadre que je compose sur Celestiar ✦"), url: saveUrl() }).catch(function () {});
    });
  }

  /* --- Init --- */
  updateSafety(); fit(); updatePrice(); syncEditor(); setMat();
  var hm = location.hash.match(/creation=([\w-]+)/);
  if (hm) { try { restore(dec(hm[1])); } catch (e) { showErr(fileErr, (CEL_EN ? "This creation link seems incomplete. You are free to start again." : "Ce lien de création semble incomplet. Vous pouvez recommencer librement.")); } }
  window.addEventListener("resize", function () { if (!holder.hidden) fit(); });
  window.STUDIO_DEBUG = { stage: stage, texts: texts, orns: orns, config: config, state: state, snapshot: snapshot, loadExample: loadExample, clean: function () { select(null); safety.visible(false); stage.batchDraw(); } };
})();
